<template>
  <div class="chats-wrapper">
    <!-- Chat List Component -->
    <ChatList :chat-groups="chatGroupData" :user-data="userData" :unread-counts="unreadCounts" :loading="loadingStuff"
      :title="isClubGroups ? 'Club Chats' : 'Team Chats'"
      :manageable="!isClubGroups || userData.userType === 'Admin'"
      @create-chat-group="chatGroupModal" @edit-chat-group="editchatGroupModal"
      @delete-chat-group="confirmDeleteChatGroup" @open-chat="chatDetailsModal" />

    <!-- Custom Chat Group Modal -->
    <div v-if="showChatGroupModal" class="modal-overlay" @click="closeModal">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Chat group</h3>
            <button type="button" class="close-button" @click="closeModal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="form__item">
              <input class="form__input full-size" type="text" placeholder="Name of group"
                v-model="selectedchatGroup.name" />
              <p v-if="selectedchatGroup.name === null">
                Please add a chat group name.
              </p>
            </div>

            <div class="user-select-wrapper" v-if="selectedchatGroup.usersFullData !== undefined">
              <p>{{ isClubGroups ? "People in chat" : "Players in chat" }}</p>
              <div class="player-list" v-for="(player, index) in selectedchatGroup.usersFullData" :key="player.id"
                :index="index">
                <label :for="player.id">
                  <img v-if="player.userImage !== '' && player.userImage !== null"
                    :src="getImgUrl(player.userImage)" alt="" />
                  <img v-else :src="getImgUrl('default-image.png')" alt="" />
                  {{ player.name }}
                </label>

                <button class="btn btn-outline-danger" @click="chatTeamMemberToggle(player.id, 'Remove')">
                  Remove
                </button>
              </div>
            </div>

            <div class="players-not-in-chat" v-if="selectedchatGroup.teamMembersNotInChat !== undefined">
              <p>{{ isClubGroups ? "People not in chat" : "Players not in chat" }}</p>

              <div class="user-select-wrapper">
                <div class="player-list" v-for="(
player, index
                  ) in selectedchatGroup.teamMembersNotInChat" :key="player.id" :index="index">
                  <label :for="player.id">
                    <img v-if="
                      player.userImage !== '' && player.userImage !== null
                    " :src="getImgUrl(player.userImage)" alt="" />
                    <img v-else :src="getImgUrl('default-image.png')" alt="" />
                    {{ player.name }}
                  </label>
                  <button class="btn btn-outline-success" @click="chatTeamMemberToggle(player.id, 'Add')">
                    Add
                  </button>
                </div>
              </div>
            </div>
            <p v-else>No players not in chat</p>
            <button v-if="editSelectedChatMode === false" @click="saveNewChatGroup()"
              class="green-button add-new-programme">
              Add chat group
            </button>

            <button v-else @click="upDateChatGroup()" class="green-button add-new-programme">
              Edit chat group
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Custom Chat Details Modal -->
    <div v-if="showChatDetailsModal" class="modal-overlay" role="dialog" aria-modal="true" tabindex="-1"
      @click="closeChatDetailsModal" @keydown.esc="closeChatDetailsModal">
      <div class="modal-dialog modal-xl modal-chatDetails" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{ selectedChat.name }}</h3>
            <button type="button" class="close-button" @click="closeChatDetailsModal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="chat-messages">
              <!-- Load More Messages Button -->
              <div v-if="hasMoreMessages && selectedChatMessages.length > 0" class="load-more-wrapper">
                <button class="btn btn-outline-primary load-more-btn" :disabled="loadingMoreMessages"
                  @click="loadMoreMessages">
                  <span v-if="loadingMoreMessages">Loading...</span>
                  <span v-else>Load More Messages</span>
                </button>
              </div>

              <!-- Connection Status -->
              <div v-if="!connectionStatus.isOnline" class="connection-status offline">
                <i class="fas fa-wifi-slash"></i>
                You are offline. Messages will sync when reconnected.
              </div>

              <template v-for="(message, index) in selectedChatMessages" :key="message.id">
                <div v-if="isNewDay(index)" class="day-chip-row">
                  <span class="day-chip">{{ dayLabel(message) }}</span>
                </div>
                <div v-if="firstUnreadMessageId && message.id === firstUnreadMessageId" class="new-messages-divider">
                  <span>New messages</span>
                </div>
                <ChatMessage :message="message" :current-user-id="userData.id" :allow-editing="true"
                  :user-data="userData" :group-size="selectedChatMemberCount" @edit-message="handleEditMessage"
                  @delete-message="handleDeleteMessage" @reply-message="startReply" @react="handleReact"
                  @vote-poll="handleVotePoll" />
              </template>

              <div v-if="selectedChatMessages.length === 0" class="empty-state">
                <img src="./img/emptyStateIllustration.svg" />
                <p>No messages...</p>
              </div>

              <div ref="bottom" class="helloo"></div>
            </div>

            <div v-if="typingText" class="typing-indicator" aria-live="polite">
              <span class="typing-dots"><span></span><span></span><span></span></span>
              {{ typingText }}
            </div>
            <div v-if="replyingTo" class="reply-bar">
              <div class="reply-bar-text">
                <span class="reply-bar-name">Replying to {{ replyingTo.name }}</span>
                <span class="reply-bar-preview">{{ replyingTo.preview }}</span>
              </div>
              <button type="button" class="reply-bar-cancel" aria-label="Cancel reply" @click="replyingTo = null">
                &times;
              </button>
            </div>
            <ChatInput v-model="selectedChat.text" :disabled="loadingStuff" :club-id="String(userData.clubId || '')"
              @send-message="handleSendMessage" @send-files="handleSendFiles" @send-poll="handleSendPoll" />
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div v-if="showDeleteConfirmModal" class="modal-overlay" @click="showDeleteConfirmModal = false">
      <div class="modal-dialog modal-sm" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Delete Chat Group</h3>
            <button type="button" class="close-button" @click="showDeleteConfirmModal = false">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete <strong>{{ chatToDelete ? chatToDelete.name : '' }}</strong>? This will
              remove the chat group and all its messages. This action cannot be undone.</p>
          </div>
          <div class="modal-footer">
            <button class="cancel-btn" @click="showDeleteConfirmModal = false">Cancel</button>
            <button class="delete-confirm-btn" @click="deleteChatGroup()">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chat } from "@/services/ChatService.js";
import ChatService from "@/services/ChatService.js";
import checkFBauthStateMixin from "@/mixin/checkFBauthState.js";
import { expandDualBandPairs } from "@/utils/seasonGradeHelper.js";
import ChatList from "./ChatList.vue";
import ChatMessage from "./ChatMessage.vue";
import ChatInput from "./ChatInput.vue";
import { avatarUrl } from "@/utils/avatar";

export default {
  name: "Chats",
  mixins: [checkFBauthStateMixin],
  emits: ["getChatGroupInfo", "getNewDataFromCollection"],
  components: {
    ChatList,
    ChatMessage,
    ChatInput,
  },
  data() {
    return {
      loadingStuff: false,
      fbUser: null,
      editSelectedChatMode: false,
      selectedChatMessages: [],
      chatGroupData: [],
      unreadCounts: {},
      unreadWatchStop: null,
      selectedChat: {
        text: "",
      },
      selectedchatGroup: {
        ageGroup: "",
        id: null,
        name: "",
        playerId: null,
        teamId: null,
        usersFullData: [],
        teamMembersNotInChat: [],
        usersInTheGroup: [],
      },
      showChatGroupModal: false,
      showChatDetailsModal: false,
      showDeleteConfirmModal: false,
      chatToDelete: null,
      chatListener: null, // Track Firebase listener
      // Pagination state
      hasMoreMessages: false, // Initialize as false, will be set by ChatService
      loadingMoreMessages: false,
      connectionStatus: { isOnline: true },
      connectionListener: null,
      // Body scroll management
      scrollPosition: 0,
      // "New messages" divider: oldest unread message id, captured once
      // per modal open BEFORE auto mark-as-read wipes the unread state.
      firstUnreadMessageId: null,
      firstUnreadCaptured: false,
      // Reply-quoting: message being replied to ({id, name, preview}).
      replyingTo: null,
      // Typing indicator state
      typingNames: [],
      typingWatchStop: null,
      typingIdleTimer: null,
      lastTypingSentAt: 0,
    };
  },
  props: {
    teamChatMessages: {
      type: Object,
      default: null,
    },
    currentTeam: {
      type: Array,
      default: null,
    },
    userData: {
      type: Object,
      default: null,
    },
    selectedTeam: {
      type: Object,
      default: null,
    },
  },
  computed: {
    // The chat view mounts one instance per team plus one for the club's
    // team-less groups (selectedTeam.id 0): admin-managed, hand-picked
    // members from the whole club.
    isClubGroups() {
      return !this.selectedTeam || !this.selectedTeam.id;
    },
    // Members in the open chat (usersInTheGroup CSV) — drives the
    // "read by everyone" tick in ChatMessage. 0 when unknown.
    selectedChatMemberCount() {
      const csv = this.selectedChat?.usersInTheGroup;
      if (!csv) return 0;
      return String(csv)
        .split(",")
        .filter((s) => s.trim() !== "").length;
    },
    typingText() {
      if (this.typingNames.length === 0) return "";
      if (this.typingNames.length === 1)
        return `${this.typingNames[0]} is typing…`;
      if (this.typingNames.length === 2)
        return `${this.typingNames[0]} and ${this.typingNames[1]} are typing…`;
      return "Several people are typing…";
    },
  },
  watch: {
    // Composer text changes → throttled "I'm typing" writes.
    "selectedChat.text"(newVal) {
      if (newVal && newVal.trim()) this.onComposerTyping();
    },
    selectedChatMessages: {
      immediate: true,
      deep: true,
      handler(newMessages) {
        if (
          newMessages &&
          newMessages.length > 0 &&
          this.showChatDetailsModal
        ) {
          // Use setTimeout to ensure modal and messages are fully rendered
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToBottom();
            }, 100);
          });
        }
      },
    },
    teamChatMessages: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
    showChatDetailsModal: {
      handler(newVal) {
        if (newVal) {
          // Modal opening - prevent body scroll
          this.preventBodyScroll();
        } else {
          // Modal closing - restore body scroll
          this.restoreBodyScroll();
        }
      },
      immediate: true,
    },
  },
  async created() {
    // Wait for auth to be ready and get the user
    this.fbUser = await this.waitForAuth();
    if (this.fbUser) {
      this.getTeamChatGroups();

      // Set up connection status monitoring
      this.connectionListener = ChatService.getConnectionStatus((status) => {
        this.connectionStatus = status;
        console.log("Connection status:", status);
      });
    }
  },
  beforeUnmount() {
    // Stop the unread-count listeners
    if (this.unreadWatchStop) {
      this.unreadWatchStop();
      this.unreadWatchStop = null;
    }

    // Clean up Firebase listeners using the service
    ChatService.removeAllListeners();

    // Clean up connection status listener
    if (this.connectionListener) {
      this.connectionListener();
      this.connectionListener = null;
    }

    // Clean up local listener if any
    if (this.chatListener) {
      this.chatListener();
      this.chatListener = null;
    }

    // Ensure body scroll is restored if modal was open
    if (this.showChatDetailsModal) {
      this.restoreBodyScroll();
    }
  },
  methods: {
    // Live unread badges: one lightweight listener per group counts recent
    // messages the user hasn't seen. Re-armed whenever the group list loads.
    startUnreadWatch() {
      if (this.unreadWatchStop) {
        this.unreadWatchStop();
        this.unreadWatchStop = null;
      }
      if (
        !this.userData ||
        !this.userData.id ||
        !this.userData.clubId ||
        this.chatGroupData.length === 0
      ) {
        return;
      }
      this.unreadWatchStop = ChatService.watchUnreadCounts(
        this.chatGroupData,
        this.userData.clubId,
        this.userData.id,
        (counts, lastMessages) => {
          this.unreadCounts = counts;
          // Same listener also carries the last-message previews — keeps
          // the list live and avoids a separate query per group.
          if (lastMessages) {
            this.chatGroupData = this.chatGroupData.map((chat) => {
              const lm = lastMessages[String(chat.id)];
              return lm ? { ...chat, ...lm } : chat;
            });
          }
        },
      );
    },
    startReply(payload) {
      this.replyingTo = payload;
    },
    // Day separators: chip shown above the first message of each day.
    isNewDay(index) {
      const msg = this.selectedChatMessages[index];
      if (!msg?.createdDate) return false;
      if (index === 0) return true;
      const prev = this.selectedChatMessages[index - 1];
      if (!prev?.createdDate) return true;
      const a = new Date(msg.createdDate);
      const b = new Date(prev.createdDate);
      return (
        a.getFullYear() !== b.getFullYear() ||
        a.getMonth() !== b.getMonth() ||
        a.getDate() !== b.getDate()
      );
    },
    dayLabel(message) {
      if (!message?.createdDate) return "";
      const t = new Date(message.createdDate);
      const now = new Date();
      const startOfDay = (d) =>
        new Date(d.getFullYear(), d.getMonth(), d.getDate());
      const diffDays = Math.round(
        (startOfDay(now) - startOfDay(t)) / 86400000,
      );
      if (diffDays === 0) return "Today";
      if (diffDays === 1) return "Yesterday";
      const opts = { weekday: "long", day: "numeric", month: "short" };
      if (t.getFullYear() !== now.getFullYear()) opts.year = "numeric";
      return t.toLocaleDateString("en-GB", opts);
    },
    async markMessagesAsRead(messages) {
      // Mark unread messages as read by current user
      if (!messages || !this.userData?.id) {
        return;
      }

      const userId = this.userData.id.toString();
      const unreadMessages = messages.filter(
        (message) =>
          message.readById === undefined || !message.readById.includes(userId),
      );

      // Mark each unread message as read
      for (const message of unreadMessages) {
        try {
          await ChatService.markMessageAsRead(message.id, userId);
        } catch (error) {
          console.error("Error marking message as read:", error);
          // Continue with other messages even if one fails
        }
      }

      if (unreadMessages.length > 0) {
        console.log(`Marked ${unreadMessages.length} messages as read`);
      }
    },
    async handleSendMessage(messageText) {
      if (!messageText || !messageText.trim()) {
        console.warn("Message text is empty");
        return;
      }

      if (!this.userData || !this.userData.id || !this.userData.clubId) {
        console.warn("User data not available");
        this.$toast?.error("User data not available");
        return;
      }

      // Optimistic send: clear the composer immediately and keep it
      // enabled — the Firestore listener paints the message locally
      // before the server ack, so there is nothing to wait for.
      const text = messageText;
      const replyTo = this.replyingTo;
      this.selectedChat.text = "";
      this.replyingTo = null;
      this.stopTyping();

      try {
        await ChatService.sendMessage(this.selectedChat.id, {
          text,
          user_id: this.userData.id.toString(),
          user_name: this.userData.name,
          user_profile_image: this.userData.userImage || "",
          clubId: this.userData.clubId.toString(),
          replyTo,
        });

        this.sendFBNotificationToAllIds();
      } catch (error) {
        console.error("Error sending message:", error);
        // Never lose what was typed — restore the text AND the quoted
        // reply (unless the user has already started something new).
        if (!this.selectedChat.text || !this.selectedChat.text.trim()) {
          this.selectedChat.text = text;
        }
        if (replyTo && !this.replyingTo) {
          this.replyingTo = replyTo;
        }
        this.$toast?.error(
          "Message didn't send — it's back in the box, press send to retry."
        );
      }
    },
    async handleSendFiles(fileData) {
      if (!fileData || !fileData.files || fileData.files.length === 0) {
        console.warn("No files to send");
        return;
      }

      if (!this.userData || !this.userData.id || !this.userData.clubId) {
        console.warn("User data not available");
        this.$toast?.error("User data not available");
        return;
      }

      // Files are already uploaded by ChatInput at this point — sending
      // is just Firestore writes, which paint locally straight away, so
      // don't lock the composer.
      const caption = fileData.message || "";
      this.selectedChat.text = "";

      try {
        for (const file of fileData.files) {
          // Store media as the JSON shape ChatMessage renders
          // ({url, category, originalName}) — a bare URL string parses
          // as JSON garbage and degrades every image to "Unknown file".
          const media =
            typeof file === "object" && file !== null
              ? JSON.stringify({
                  url: file.url || file.path || "",
                  category: file.category || "document",
                  originalName: file.name || file.fileName || "",
                  filename: file.fileName || "",
                })
              : JSON.stringify({ url: String(file), category: "document" });
          await ChatService.sendMessage(this.selectedChat.id, {
            text: caption,
            user_id: this.userData.id.toString(),
            user_name: this.userData.name,
            user_profile_image: this.userData.userImage || "",
            clubId: this.userData.clubId.toString(),
            media,
          });
        }

        this.sendFBNotificationToAllIds();
      } catch (error) {
        console.error("Error sending files:", error);
        if (caption && (!this.selectedChat.text || !this.selectedChat.text.trim())) {
          this.selectedChat.text = caption;
        }
        this.$toast?.error("Failed to send file(s). Please try again.");
      }
    },
    async handleSendPoll(pollData) {
      if (
        !pollData ||
        !pollData.question ||
        !Array.isArray(pollData.options) ||
        pollData.options.length < 2
      ) {
        console.warn("Poll data incomplete");
        return;
      }

      if (!this.userData || !this.userData.id || !this.userData.clubId) {
        console.warn("User data not available");
        this.$toast?.error("User data not available");
        return;
      }

      try {
        await ChatService.sendPoll(this.selectedChat.id, {
          question: pollData.question,
          options: pollData.options,
          allowMultiple: !!pollData.allowMultiple,
          user_id: this.userData.id.toString(),
          user_name: this.userData.name,
          user_profile_image: this.userData.userImage || "",
          clubId: this.userData.clubId.toString(),
        });

        this.sendFBNotificationToAllIds();
      } catch (error) {
        console.error("Error sending poll:", error);
        this.$toast?.error("Poll didn't send — please try again.");
      }
    },
    handleVotePoll({ messageId, optionIndex, allowMultiple, myVotes }) {
      ChatService.voteOnPoll(
        messageId,
        optionIndex,
        this.userData.id,
        allowMultiple,
        myVotes,
      ).catch((error) => {
        console.error("Error voting on poll:", error);
        this.$toast?.error("Couldn't record your vote");
      });
    },
    async handleEditMessage(editData) {
      try {
        await ChatService.updateMessage(editData.messageId, {
          text: editData.newContent,
        });
        this.$toast?.success("Message updated successfully");
      } catch (error) {
        console.error("Error editing message:", error);
        this.$toast?.error("Failed to edit message");
      }
    },
    async handleDeleteMessage(messageId) {
      if (!messageId) {
        console.error("No message ID provided for deletion");
        this.$toast?.error("Invalid message selected for deletion");
        return;
      }

      try {
        // Show loading state
        this.loadingStuff = true;

        // Permanently delete message from Firebase
        await ChatService.deleteMessage(messageId);

        // Immediately remove the deleted message from the UI
        this.selectedChatMessages = this.selectedChatMessages.filter(
          (message) => message.id !== messageId,
        );

        this.$toast?.success("Message deleted successfully");

        console.log(
          `Message ${messageId} permanently deleted from Firebase and removed from UI`,
        );
      } catch (error) {
        console.error("Error deleting message:", error);
        this.$toast?.error("Failed to delete message");
      } finally {
        this.loadingStuff = false;
      }
    },
    async saveNewChatGroup() {
      if (this.selectedchatGroup.name !== "") {
        this.loadingStuff = true;
        const data = {
          action: "saveNewChatGroup",
          name: this.selectedchatGroup.name,
          usersInTheGroup: this.getAllSelectedUsersInTheGroupIds(),
          ageGroup: this.selectedTeam.age_group,
          teamId: this.selectedTeam.id,
          clubId: this.userData.clubId,
          playerId: this.userData.id,
        };

        const response = await Chat.find(data).catch((error) => {
          console.log(error);
        });

        this.loadingStuff = false;
        if (response && response.status === 200) {
          this.getTeamChatGroups();
          this.showChatGroupModal = false;
          this.$toast.success("Chat group added");
        }
      } else {
        this.selectedchatGroup.name = "";
      }
    },
    async upDateChatGroup() {
      this.loadingStuff = true;

      const data = {
        id: this.selectedchatGroup.id,
        action: "upDateChatGroup",
        name: this.selectedchatGroup.name,
        usersInTheGroup: this.getAllSelectedUsersInTheGroupIds(),
        ageGroup: this.selectedchatGroup.age_group,
        teamId: this.selectedchatGroup.teamId,
        playerId: this.selectedchatGroup.playerId,
      };

      const response = await Chat.find(data).catch((error) => {
        console.log(error);
      });

      this.loadingStuff = false;
      if (response && response.status === 200) {
        this.getTeamChatGroups();
        this.showChatGroupModal = false;
        this.$toast.success("Chat group updated");
      }
    },
    confirmDeleteChatGroup(chat) {
      this.chatToDelete = chat;
      this.showDeleteConfirmModal = true;
    },
    async deleteChatGroup() {
      if (!this.chatToDelete) return;

      this.loadingStuff = true;
      this.showDeleteConfirmModal = false;

      try {
        // Delete all Firebase messages for this chat group
        const clubId = this.userData?.clubId;
        if (clubId) {
          await ChatService.deleteAllChatMessages(this.chatToDelete.id, clubId);
        }

        // Delete the chat group from the database
        const data = {
          id: this.chatToDelete.id,
          action: "deleteChatGroup",
        };

        const response = await Chat.find(data).catch((error) => {
          console.log(error);
        });

        if (response && response.status === 200) {
          this.getTeamChatGroups();
          this.chatToDelete = null;
          this.$toast.success("Chat group and all messages deleted");
        } else {
          this.$toast.error("Failed to delete chat group");
        }
      } catch (error) {
        console.error("Error deleting chat group:", error);
        this.$toast.error("Failed to delete chat group");
      } finally {
        this.loadingStuff = false;
      }
    },
    getAllSelectedUsersInTheGroupIds() {
      let playerIds = [];
      this.selectedchatGroup.usersFullData.map((player) => {
        playerIds.push(player.id);
      });
      return playerIds.toString();
    },
    getRandomInt() {
      return Math.floor(Math.random() * 1000 + 1);
    },
    chatGroupModal() {
      this.editSelectedChatMode = false;
      this.selectedchatGroup = {
        ageGroup: "",
        id: null,
        name: "",
        playerId: null,
        teamId: null,
        usersFullData: this.currentTeam,
        teamMembersNotInChat: [],
        usersInTheGroup: [],
      };
      if (this.selectedchatGroup.id === null) {
        this.selectedchatGroup.id = this.getRandomInt();
      }

      setTimeout(() => {
        this.showChatGroupModal = true;
      }, 100);
    },
    async getTeamChatGroups() {
      this.loadingStuff = true;

      const teamId = this.selectedTeam?.id;

      const data = {
        action: "getTeamChatGroupsForUser",
        teamId: teamId,
      };
      if (this.isClubGroups) {
        // Club groups (teamId 0) are membership-scoped server-side:
        // admins get them all, everyone else only the ones they're in.
        data.clubId = this.userData.clubId;
        data.playerId = this.userData.id;
        data.userType = this.userData.userType;
      }

      const response = await Chat.find(data).catch((error) => {
        console.log("getTeamChatGroups: API error =", error);
      });

      this.loadingStuff = false;
      if (response && response.status === 200) {
        // Last-message previews arrive via the unread watcher's shared
        // listeners (startUnreadWatch) — no per-group one-shot fetch.
        this.chatGroupData = [...response.data];
        this.startUnreadWatch();
        this.$emit("getChatGroupInfo", {
          chatGroup: response.data,
          collection: this.teamChatMessages,
        });
      } else {
        console.error("getTeamChatGroups: Invalid response", response);
        this.$toast?.error("Failed to load chat groups. Please try again.");
      }
    },
    chatTeamMemberToggle(value, type) {
      const playerId = Number(value);

      const togglePlayer = (sourceArray, targetArray) => {
        const playerToMove = sourceArray.find(
          (player) => player.id === playerId,
        );

        if (!playerToMove) return;
        const updatedSourceArray = sourceArray.filter(
          (player) => player.id !== playerId,
        );
        const updatedTargetArray = [...targetArray, playerToMove];

        return {
          sourceArray: updatedSourceArray,
          targetArray: updatedTargetArray,
        };
      };

      if (type === "Remove") {
        const result = togglePlayer(
          this.selectedchatGroup.usersFullData,
          this.selectedchatGroup.teamMembersNotInChat,
        );

        if (result) {
          this.selectedchatGroup.usersFullData = [...result.sourceArray];
          this.selectedchatGroup.teamMembersNotInChat = [...result.targetArray];
        }
      }
      if (type === "Add") {
        const result = togglePlayer(
          this.selectedchatGroup.teamMembersNotInChat,
          this.selectedchatGroup.usersFullData,
        );

        if (result) {
          this.selectedchatGroup.teamMembersNotInChat = [...result.sourceArray];
          this.selectedchatGroup.usersFullData = [...result.targetArray];
        }
      }
    },
    async editchatGroupModal(chatData) {
      if (this.currentTeam === null) {
        return;
      }
      this.editSelectedChatMode = true;
      this.selectedchatGroup.id = chatData.id;
      this.selectedchatGroup.ageGroup = chatData.ageGroup;
      this.selectedchatGroup.name = chatData.name;
      this.selectedchatGroup.playerId = chatData.playerId;
      this.selectedchatGroup.teamId = chatData.teamId;
      this.selectedchatGroup.usersInTheGroup = chatData.usersInTheGroup;
      this.selectAllPlayersInTheChat();
      setTimeout(() => {
        this.showChatGroupModal = true;
      }, 100);
    },
    selectAllPlayersInTheChat() {
      // Add null safety checks
      if (!this.selectedchatGroup.usersInTheGroup) {
        this.selectedchatGroup.usersFullData = [];
        this.selectedchatGroup.teamMembersNotInChat = [];
        return;
      }

      let usersInGroupData = this.selectedchatGroup.usersInTheGroup.split(",");
      if (this.currentTeam === null) {
        // Add null safety check for selectedTeam and playersInTeam
        if (!this.selectedTeam || !this.selectedTeam.playersInTeam) {
          this.selectedchatGroup.usersFullData = [];
          this.selectedchatGroup.teamMembersNotInChat = [];
          return;
        }

        this.selectedchatGroup.usersFullData = usersInGroupData
          .map((id) =>
            this.selectedTeam.playersInTeam.find(
              (player) => player && player.id === Number(id),
            ),
          )
          .filter((player) => player !== undefined); // Filter out undefined values
        this.selectedchatGroup.teamMembersNotInChat = this.findMissingObjects(
          this.selectedTeam.playersInTeam,
          this.selectedchatGroup.usersFullData,
        );
      } else {
        // Add null safety check for currentTeam
        if (!this.currentTeam) {
          this.selectedchatGroup.usersFullData = [];
          this.selectedchatGroup.teamMembersNotInChat = [];
          return;
        }

        this.selectedchatGroup.usersFullData = usersInGroupData
          .map((id) =>
            this.currentTeam.find(
              (player) => player && player.id === Number(id),
            ),
          )
          .filter((player) => player !== undefined); // Filter out undefined values
        this.selectedchatGroup.teamMembersNotInChat = this.findMissingObjects(
          this.currentTeam,
          this.selectedchatGroup.usersFullData,
        );
      }
    },
    chatDetailsModal(chatData) {
      console.log("Chat selected:", chatData);
      this.selectedChat = chatData;

      // Ensure we have a valid chat ID before loading messages
      if (!this.selectedChat?.id) {
        console.error("No chat ID found in selected chat:", this.selectedChat);
        this.$toast?.error("Invalid chat selected. Please try again.");
        return;
      }

      this.getTeamChatMessages();
      setTimeout(() => {
        this.showChatDetailsModal = true;

        // Ensure scroll to bottom after modal is fully opened
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToBottom();
          }, 200);
        });
      }, 100);
    },
    async getTeamChatMessages() {
      try {
        console.log("Loading messages for chat:", this.selectedChat);

        // Clean up any existing listener
        if (this.chatListener) {
          this.chatListener();
          this.chatListener = null;
        }

        // Fresh unread-divider capture for this visit
        this.firstUnreadMessageId = null;
        this.firstUnreadCaptured = false;
        this.replyingTo = null;

        // Typing watch for this chat (replaces any previous one)
        if (this.typingWatchStop) this.typingWatchStop();
        this.typingNames = [];
        this.typingWatchStop = ChatService.watchTyping(
          this.selectedChat.id,
          this.userData.clubId,
          this.userData.id,
          (names) => {
            this.typingNames = names;
          },
        );

        // Auth check removed - now using HTTP API

        // Validate chat ID
        if (!this.selectedChat?.id) {
          console.error("Cannot load messages: missing chat ID");
          return;
        }

        console.log(
          "Setting up ChatService listener for chatId:",
          this.selectedChat.id,
        );

        // Validate user data for Firebase filtering
        if (!this.userData?.clubId) {
          console.error("Cannot load messages: missing user clubId");
          this.$toast?.error(
            "User data not available. Please refresh the page.",
          );
          return;
        }

        // Use the Firebase ChatService for real-time messages with pagination (20 messages initially)
        this.chatListener = ChatService.getChatMessages(
          this.selectedChat.id,
          this.userData.clubId, // clubId for Firebase filtering
          (result) => {
            console.log("Firebase ChatService callback result:", result);

            if (result.error) {
              console.error("Error fetching Firebase messages:", result.error);
              this.$toast?.error(
                "Failed to load chat messages. Please refresh the page.",
              );
              return;
            }

            // Update reactive data with pagination info
            this.selectedChatMessages = result.messages;
            this.hasMoreMessages = result.hasMore;

            // Capture the oldest unread message for the "New messages"
            // divider BEFORE marking everything read below.
            if (!this.firstUnreadCaptured && result.messages.length > 0) {
              this.firstUnreadCaptured = true;
              const uid = this.userData.id.toString();
              const firstUnread = result.messages.find(
                (m) =>
                  m.userId?.toString() !== uid &&
                  (!m.readById || !m.readById.includes(uid)),
              );
              this.firstUnreadMessageId = firstUnread ? firstUnread.id : null;
            }

            // Mark messages as read for current user
            this.markMessagesAsRead(result.messages);

            console.log(
              `Loaded ${result.messages.length} Firebase messages, hasMore: ${result.hasMore}`,
            );
          },
          20, // Load only 20 messages initially instead of 100
        );
      } catch (error) {
        console.error("Error setting up chat messages:", error);
        this.$toast?.error(
          "Failed to load chat messages. Please refresh the page.",
        );
      }
    },
    async loadMoreMessages() {
      if (this.loadingMoreMessages || !this.hasMoreMessages) {
        return;
      }

      this.loadingMoreMessages = true;

      try {
        const result = await ChatService.loadMoreMessages(
          this.selectedChat.id,
          this.userData.clubId,
          20, // Load 20 more messages
        );

        if (result.error) {
          console.error("Error loading more messages:", result.error);
          this.$toast?.error("Failed to load more messages");
          return;
        }

        // Prepend older messages to the beginning of the array
        this.selectedChatMessages = [
          ...result.messages,
          ...this.selectedChatMessages,
        ];
        this.hasMoreMessages = result.hasMore;

        console.log(
          `Loaded ${result.messages.length} more messages, hasMore: ${result.hasMore}`,
        );
      } catch (error) {
        console.error("Error loading more messages:", error);
        this.$toast?.error("Failed to load more messages");
      } finally {
        this.loadingMoreMessages = false;
      }
    },
    sendFBNotificationToAllIds() {
      if (!this.selectedChat?.id) {
        console.warn("sendFBNotificationToAllIds: No chat selected");
        return;
      }
      // Single group-scoped notification. The backend resolves recipients
      // from the chat's usersInTheGroup + ALL of the team's coaches, minus
      // the sender — replacing the old per-id loop + single coach_id call.
      this.sendFBNotificationMessage(
        `A new message has been posted to the ${this.selectedTeam.teamName} ${this.selectedChat.name} chat`,
        `You have a new message to review from ${this.selectedTeam.teamName}`,
        [],
        null,
        false,
      );
    },
    findMissingObjects(array1, array2, comparisonKey = "id") {
      // Add null safety checks to prevent errors when objects are undefined
      if (!Array.isArray(array1) || !Array.isArray(array2)) {
        return [];
      }

      return array1.filter(
        (obj1) =>
          obj1 && // Check if obj1 exists
          obj1[comparisonKey] !== undefined && // Check if comparison property exists
          !array2.some(
            (obj2) =>
              obj2 && // Check if obj2 exists
              obj2[comparisonKey] !== undefined && // Check if comparison property exists
              obj2[comparisonKey] === obj1[comparisonKey],
          ),
      );
    },
    async sendFBNotificationMessage(
      title,
      body,
      ageGroup,
      playerId,
      showToast,
    ) {
      // Expand dual-band pairs (e.g. U17 squad covers 2009-2010 in
      // 2025-26 season) so notifications reach both birth-year cohorts.
      // Replaces the previous hardcoded "2007↔2008, 2009↔2010" checks
      // which would silently target the wrong years after each rollover.
      // The helper recomputes the pairing from the current season each
      // call — no maintenance needed at season changeover.
      const expandedAgeGroup =
        ageGroup && ageGroup.length !== 0
          ? expandDualBandPairs(ageGroup)
          : ageGroup;

      const data = {
        action: "sendFBNotificationMessage",
        title: title,
        body: body,
        link: `${window.location.origin}/chats`,
        age_group: expandedAgeGroup,
        player_id: playerId,
        // chatId (with no player_id/age_group) makes the backend scope
        // recipients to the group's members + the team's coaches; senderId
        // excludes the author. See getGroupNotificationTokens().
        chatId: this.selectedChat?.id ?? null,
        senderId: this.userData?.id ?? null,
        clubId: this.userData?.clubId,
      };
      const response = await Chat.find(data).catch((error) => {
        console.log(error);
      });
      if (response && response.status === 200 && showToast === true) {
        this.$toast.success("Notification sent");
      }
    },
    getImgUrl(pic) {
      // Empty stays empty (callers rely on rendering nothing); a stored
      // "default-image.png" resolves to the neutral avatar via avatarUrl.
      return pic !== undefined && pic !== "" ? avatarUrl(pic) : "";
    },
    closeModal() {
      this.showChatGroupModal = false;
    },
    closeChatDetailsModal() {
      // Clean up listeners without triggering component rerender
      this.cleanupChatListener();
      this.stopTyping();
      this.showChatDetailsModal = false;
    },
    cleanupChatListener() {
      // Dedicated cleanup method that doesn't emit events
      if (this.chatListener) {
        console.log("Cleaning up chat listener on modal close");
        this.chatListener();
        this.chatListener = null;
      }
      if (this.typingWatchStop) {
        this.typingWatchStop();
        this.typingWatchStop = null;
      }
      this.typingNames = [];
    },
    // --- Typing indicator plumbing -------------------------------------
    onComposerTyping() {
      if (!this.showChatDetailsModal || !this.selectedChat?.id) return;
      const now = Date.now();
      if (now - this.lastTypingSentAt > 2500) {
        this.lastTypingSentAt = now;
        ChatService.setTyping(
          this.selectedChat.id,
          this.userData.clubId,
          this.userData.id,
          this.userData.name,
          true,
        ).catch(() => {});
      }
      clearTimeout(this.typingIdleTimer);
      this.typingIdleTimer = setTimeout(() => this.stopTyping(), 4000);
    },
    stopTyping() {
      clearTimeout(this.typingIdleTimer);
      this.typingIdleTimer = null;
      this.lastTypingSentAt = 0;
      if (!this.selectedChat?.id || !this.userData?.id) return;
      ChatService.setTyping(
        this.selectedChat.id,
        this.userData.clubId,
        this.userData.id,
        this.userData.name,
        false,
      ).catch(() => {});
    },
    handleReact({ messageId, emoji, hasReacted }) {
      ChatService.toggleReaction(
        messageId,
        emoji,
        this.userData.id,
        hasReacted,
      ).catch((error) => {
        console.error("Error toggling reaction:", error);
        this.$toast?.error("Couldn't update reaction");
      });
    },
    preventBodyScroll() {
      // Store current scroll position
      this.scrollPosition = window.pageYOffset;

      // Apply modal-open class to body
      document.body.classList.add("modal-open");

      // iOS Safari specific handling
      if (this.isIOSSafari()) {
        document.body.classList.add("modal-open-ios");
        document.body.style.top = `-${this.scrollPosition}px`;
      }
    },
    restoreBodyScroll() {
      // Remove modal classes
      document.body.classList.remove("modal-open", "modal-open-ios");

      // Restore scroll position on iOS
      if (this.isIOSSafari() && this.scrollPosition !== undefined) {
        document.body.style.top = "";
        window.scrollTo(0, this.scrollPosition);
      }
    },
    isIOSSafari() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    scrollToBottom() {
      // Enhanced scroll to bottom method with multiple fallbacks
      if (!this.showChatDetailsModal) {
        console.log("Modal not open, skipping scroll");
        return;
      }

      const bottomElement = this.$refs["bottom"];
      if (!bottomElement) {
        console.log("Bottom element not found, retrying in 50ms");
        setTimeout(() => this.scrollToBottom(), 50);
        return;
      }

      try {
        // Primary method: scrollIntoView with smooth behavior
        bottomElement.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });

        console.log("Scrolled to bottom successfully");
      } catch (error) {
        console.warn("scrollIntoView failed, trying fallback:", error);

        // Fallback 1: Find the chat messages container and scroll manually
        const chatMessagesContainer = bottomElement.closest(".chat-messages");
        if (chatMessagesContainer) {
          chatMessagesContainer.scrollTop = chatMessagesContainer.scrollHeight;
          console.log("Fallback scroll successful");
        } else {
          console.warn("Could not find chat messages container for scrolling");
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.chats-wrapper {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.green-button {
  margin-bottom: 1rem;
}

.team-chat-wrapper {
  width: 100%;

  .team-chat-list-item {
    padding: 2rem;
    margin-bottom: 2rem;
    padding: 1rem;
    background: white;
    padding: 1rem;
    border-radius: 4px;
    cursor: pointer;
    max-width: 43rem;
    -webkit-box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
    box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
    border: 1px solid transparent;
    margin-bottom: 2rem;
    position: relative;

    &:hover,
    &:focus {
      border: 1px solid $secondary-color;
      cursor: pointer;
    }

    .chat-item {
      p {
        margin: 0;
      }

      img {
        width: 6rem;
        margin: 0 auto 0.5rem auto;
        display: block;
      }
    }

    .player-game-responce {
      button {
        margin: 0;
      }
    }

    .unreadMessages-wrapper {
      background: #e60000;
      width: 2rem;
      display: block;
      border-radius: 100px;
      text-align: center;
      color: white;
      font-size: 0.9rem;
      font-weight: bold;
      position: absolute;
      top: -1rem;
      right: 1rem;
      height: 2rem;
      line-height: 2rem;
    }

    .hidden {
      display: none;
    }
  }
}

.wrapper {
  position: relative;
  display: inline-block;
}

.emoji-invoker {
  position: absolute;
  top: 2rem;
  right: 15%;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  background: transparent;
  border: 0;
}

.emoji-invoker:hover {
  transform: scale(1.1);
}

.emoji-invoker > svg {
  fill: #b1c6d0;
}

/* Emoji picker wrapper styles */
.emoji-picker-wrapper {
  position: relative;
  display: inline-block;
}

.emoji-picker-popup {
  position: absolute;
  z-index: 1000;
  top: 100%;
  left: 0;
  margin-top: 5px;
  box-shadow: 1px 1px 8px #c7dbe6;
  border-radius: 0.5rem;
  max-width: 300px;
}

.chat-messages {
  overflow-y: scroll;
  height: 62vh;
  padding: 1rem;
  position: relative;
  background: #fafafa;

  // Load More Button Styles
  .load-more-wrapper {
    text-align: center;
    margin-bottom: 1rem;
    padding: 1rem 0;
    border-bottom: 1px solid #e0e0e0;

    .load-more-btn {
      background: #ffffff;
      border: 1px solid #13519d;
      color: #13519d;
      padding: 0.5rem 1.5rem;
      border-radius: 0.25rem;
      font-size: 0.9rem;
      transition: all 0.2s ease;

      &:hover:not(:disabled) {
        background: #13519d;
        color: white;
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }

  // Connection Status Styles
  .connection-status {
    padding: 0.5rem 1rem;
    margin-bottom: 1rem;
    border-radius: 0.25rem;
    text-align: center;
    font-size: 0.9rem;

    &.offline {
      background: #fff3cd;
      border: 1px solid #ffeaa7;
      color: #856404;

      i {
        margin-right: 0.5rem;
      }
    }
  }

  .chat-details {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    img {
      height: 2rem;
      border-radius: 100px;
      border: 1px solid;
    }

    .chat-wrapper {
      background: #ece9e9;
      margin: 0 1rem 1rem 0;
      padding: 1rem;
      border-radius: 10px;
      color: #13519d;
      max-width: 90%;

      .chat-name-time-wrapper {
        display: flex;

        span.chat-name {
          display: block;
          font-size: 0.9rem;
          color: #2a8ce2;
        }

        span.chat-time {
          font-size: 0.8rem;
        }
      }
    }
  }

  .chat-details.receiver {
    justify-content: flex-end;

    .chat-wrapper {
      background: #e1f5d7;
    }
  }
}

.player-list {
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;

  img {
    width: 50px;
    margin-right: 0.5rem;
    border-radius: 100px;
    height: 50px;
    margin-bottom: 0.5rem;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    background: #f8f8f8;
  }
}

.message-input {
  position: sticky;
  width: 100%;
  background: white;
  padding: 1rem;
  left: 0;
  bottom: 0;

  .form__item {

    input.form__input,
    #textarea-default {
      width: 90%;
      margin-right: 1rem;
      font-weight: normal !important;
    }

    #save_chat_maeesage {
      position: absolute;
      right: 0%;
      top: 16px;
    }
  }
}

// Day separator chip between messages from different days
.day-chip-row {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;

  .day-chip {
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 2px 12px;
    font-size: 0.72rem;
    font-weight: 600;
    color: #64748b;
  }
}

// "X is typing…" line above the composer
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: #64748b;
  padding: 2px 4px 6px;

  .typing-dots {
    display: inline-flex;
    gap: 3px;

    span {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #94a3b8;
      animation: typingBounce 1.2s infinite ease-in-out;

      &:nth-child(2) {
        animation-delay: 0.15s;
      }

      &:nth-child(3) {
        animation-delay: 0.3s;
      }
    }
  }
}

@keyframes typingBounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  30% {
    transform: translateY(-3px);
    opacity: 1;
  }
}

// Reply bar above the composer while quoting a message
.reply-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(42, 140, 226, 0.08);
  border-left: 3px solid #2a8ce2;
  border-radius: 6px;
  padding: 6px 10px;
  margin: 0 0 6px;

  .reply-bar-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
  }

  .reply-bar-name {
    font-size: 0.75rem;
    font-weight: 700;
    color: #2a8ce2;
  }

  .reply-bar-preview {
    font-size: 0.8rem;
    color: #475569;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .reply-bar-cancel {
    border: none;
    background: none;
    font-size: 1.2rem;
    line-height: 1;
    color: #64748b;
    cursor: pointer;
    padding: 2px 6px;
  }
}

// "New messages" divider above the first unread message
.new-messages-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.5rem 1rem;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(37, 99, 235, 0.4);
  }

  span {
    font-size: 0.72rem;
    font-weight: 700;
    color: #2563eb;
    white-space: nowrap;
  }
}
</style>

<style lang="scss">
/* Custom Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  /* iOS Safari fix: ensure modal stays above navigation */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.modal-dialog {
  background-color: white;
  border-radius: 0.3rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.5);
  max-width: 500px;
  width: 90%;
  height: calc(100% - 1rem);
  overflow: auto;
}

.modal-dialog.modal-lg {
  max-width: 800px;
}

.modal-dialog.modal-sm {
  max-width: 420px;
  height: auto;
}

.modal-dialog.modal-xl {
  max-width: 1140px;
}

.modal-dialog.modal-chatDetails {
  max-width: 1140px;

  .modal-body {
    overflow: hidden;
  }
}

.modal-content {
  border: none;
  border-radius: 0.3rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem !important;
  border-bottom: 1px solid #dee2e6 !important;
  background-color: #f8f9fa;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6c757d;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #000;
}

.modal-body {
  padding: 1rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
}

.cancel-btn {
  padding: 8px 20px;
  background: #f0f2f5;
  color: #050505;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #e4e6eb;
  }
}

.delete-confirm-btn {
  padding: 8px 20px;
  background: #e41e3f;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #c41835;
  }
}

/* Button styles for replaced Bootstrap buttons */
.btn {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  text-decoration: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
  background-color: transparent;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-success {
  color: #28a745;
  border-color: #28a745;
  background-color: transparent;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

/* Body scroll prevention for modals */
.modal-open {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
}

/* iOS Safari specific fixes */
.modal-open-ios {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}
</style>
